import NewsAd from "./NewsAd";

export default ({ index = 1 }: { index: number }) => (
  <NewsAd
    unit={`/news/article_${index}`}
    className="additional"
    sizes={{
      desktop: [728, 90],
      mobile: [
        [320, 50],
        [300, 250],
      ],
    }}
  />
);
